import { Set } from '../types'
import { set } from '../utils'

export type DurationRecord<T> = Record<10 | 15 | 20 | 25 | 30, T>
export type LanguageRecord<T> = Record<'fr' | 'en', T>

export interface Category {
  _id: string
  slug: string
  short: LanguageRecord<string>
  long: LanguageRecord<string>
  image: string
  type: 'theme' | 'book' | 'background'
  parent?: {
    _id: string
    short: LanguageRecord<string>
    long: LanguageRecord<string>
  }
}

export interface AudioTheme {
  _id: string
  slug: string
  short: LanguageRecord<string>
  title: LanguageRecord<string>
  description: LanguageRecord<string>
  image?: string
  cover?: string
  tracks: LanguageRecord<DurationRecord<number>>
  contentCategory: string
}

export interface AudioBackground {
  _id: string
  slug: string
  short: LanguageRecord<string>
  long: LanguageRecord<string>
  tracks: DurationRecord<number>
  mode?: 'music-only' | 'always'
  image?: string
  contentCategory: string
}

export interface AudioBook {
  _id: string
  slug: string
  category: 'club' | 'book'
  language: 'fr' | 'en'
  title: { short: string; long: string }
  description: string
  image?: string
  cover?: string
  backgrounds?: string[]
  chapters: {
    _id: string
    title: string
    tracks: DurationRecord<number>
  }[]
  contentCategory: string
}

export interface Gong {
  _id: string
  slug: string
  short: LanguageRecord<string>
  image?: string
  cover?: string
}

interface ModelAudio {
  // State
  themes: AudioTheme[]
  books: AudioBook[]
  backgrounds: AudioBackground[]
  categories: Category[]
  gongs: Gong[]

  // Actions
  setThemes: Set<this, 'themes'>
  setBooks: Set<this, 'books'>
  setBackgrounds: Set<this, 'backgrounds'>
  setCategories: Set<this, 'categories'>
  setGongs: Set<this, 'gongs'>
}

export const modelAudio: ModelAudio = {
  // State
  themes: [],
  books: [],
  backgrounds: [],
  categories: [],
  gongs: [],
  // Actions
  setThemes: set('themes'),
  setBooks: set('books'),
  setBackgrounds: set('backgrounds'),
  setCategories: set('categories'),
  setGongs: set('gongs'),
}
